import {
  RouteReuseStrategy,
  DetachedRouteHandle,
  ActivatedRouteSnapshot,
} from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private static handlers: { [key: string]: DetachedRouteHandle } = {};

  public static clearCache(path?: string) {
    if (path) {
      delete CustomRouteReuseStrategy.handlers[path];
    } else {
      CustomRouteReuseStrategy.handlers = {};
    }
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Only reuse specific routes based on their path
    const path = route.routeConfig?.path;
    return (
      path === 'Dashboard' ||
      path === 'equipment' ||
      path === 'listed-equipment' ||
      path === 'booking' ||
      path === 'home'
    );
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (route.routeConfig && route.routeConfig.path) {
      if (handle) {
        CustomRouteReuseStrategy.handlers[route.routeConfig.path] = handle;
      }
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (!route.routeConfig || !route.routeConfig.path) return false;
    return !!CustomRouteReuseStrategy.handlers[route.routeConfig.path];
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (!route.routeConfig || !route.routeConfig.path) return null;
    return CustomRouteReuseStrategy.handlers[route.routeConfig.path] || null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
